import { RawScenario } from '../types/rawScenario';
import { request } from './index';
import { Loadable /*, RecoilLoadable */ } from 'recoil';
// import scenario from '../json/sample1';

interface GetQuestionParam {
  token: string;
  questionId: number;
}
export const getQuestionScenario = (param: GetQuestionParam): Loadable<RawScenario> => {
  // return RecoilLoadable.of(scenario);
  return request('GetQuestionScenario', param)
    .map((data: any) => ({
      ...data,
      scenarioBasicInfo: JSON.parse(data.scenarioBasicInfo),
      scenarioPageInfo: JSON.parse(data.scenarioPageInfo),
      personalInfo: data.personalInfo,
    } as RawScenario));
}
